/**
 * @file   src\components\CWInput.tsx
 * @brief  Input with label component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { InputProperty } from '../interfaces/generalInterface';
import { Form } from '../utils/thirdpartyComponents';
import "../components/CWInput.scss";

const CWSwitch = ({
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  label,
  isMandatory,
  autoFocus,
  errorMessage,
  value,
  id,
  name,
  type,
  accept,
  pattern,
  placeholder,
  disabled,
  maxLength,
  step,
  checked
}: InputProperty) => {

  return (
    <div className="custom-switch-input">
      <div className="cw-toggle-switch">
        <input
          name={name}
          id={id}
          onChange={onChange}
          disabled={disabled}
          type="checkbox"
          checked={checked}
        />
        <label htmlFor="label">
          {label}
        </label>
      </div>
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
    </div>
  );
};

export default CWSwitch;
